import { environment } from '../../../environments/environment';

export const API_ENDPOINT = environment.backendEndpoint;
export const S3_ASSETS_BASE = environment.S3_ASSETS_BASE;
export const S3_MEDIA_BASE = environment.S3_MEDIA_BASE;
export const MAIN_ENDPOINT = environment.mainEndpoint;
